import $ from 'cash-dom';
import EmblaCarousel from 'embla-carousel';
import { setupDotBtns, generateDotBtns, selectDotBtn } from "./embla-dot-helpers";

function checkSlides() {
    if ($('.slideshow-component .slideshow-slide').length > 2) {
        return true
    } else {
        return false
    }
}

$(function(){

    if ($('.slideshow-component').length != 0) {
        const sliderParent = document.querySelector('.slideshow-component');
        const sliderNode =  sliderParent.querySelector('.slideshow__wrapper');
        const options = {
            loop: checkSlides(),
            containerSelector: '.slideshow__inner'
        };

        const slider = EmblaCarousel(sliderNode, options)
        const dotsFeatured = sliderParent.querySelector('.slideshow-pagination');
        let dotsFeaturedArr = generateDotBtns(dotsFeatured, slider);
        let setSelectedDotBtn = selectDotBtn(dotsFeaturedArr, slider);

        setupDotBtns(dotsFeaturedArr, slider);
        slider.on('select', setSelectedDotBtn);
        slider.on('init', setSelectedDotBtn);
    }
})